import { BlocksRenderer } from '@strapi/blocks-react-renderer'
import { FC, useState } from 'react'

const CardExpert: FC<ICardExpert> = ({
  name,
  designation,
  location,
  biography,
  image
}) => {
  const [open, setOpen] = useState(false)
  return (
    <div className='flex flex-col items-left leading-[0.85] cursor-pointer' onClick={() => setOpen(!open)}>
      <img
        className='mb-1'
        src={`https://dza2a2ql7zktf.cloudfront.net/binaries-cdn/dqzqcuqf9/image/fetch/q_auto,dpr_1.0,g_auto,f_auto/${image}`}
        // src={image}
        alt={name}
      />
      <div className='px-7'>
        <div className='text-[35px] uppercase font-abcd'>{name}</div>
        <p className='text-[19px] uppercase font-abcd'>{designation}</p>
        <p className='text-[19px] uppercase font-abcd'>{location}</p>
        <div className='w-full max-w-md mb-2'>
          <p
            className={`text-[19px] font-swinton overflow-hidden duration-300 ease-in-out ${open ? 'max-h' : 'max-h-0'}`}
          >
            {biography && (
              <BlocksRenderer
                content={biography as any}
                blocks={{
                  paragraph: ({ children }) => <p>{children}</p>
                }}
              />
            )}
          </p>
        </div>
      </div>
    </div>
  )
}

interface ICardExpert {
  name: string
  designation: string
  location: string
  biography: string
  image: string
}

export default CardExpert